import {
    USER_LOGOUT, FETCH_ADMIN_GBG_PRODUCTS,DELETE_ADMIN_GBG_PRODUCT,
    ADD_SELECTED_GBG_PRODUCTS,REMOVE_SELECTED_GBG_PRODUCTS,CLEAR_SELECTED_GBG_PRODUCTS,
    ADD_ADMIN_GBG_PRODUCT,
      UPDATE_ADMIN_GBG_PRODUCT  }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0,selectedProducts:[] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_GBG_PRODUCTS:
            console.log('in FETCH_ADMIN_GBG_PRODUCTS',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }
        case ADD_ADMIN_GBG_PRODUCT:
           // console.log('ADD_ADMIN_GBG_PRODUCT', state, action.payload);

            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                 total:state.total+1,
            }
        case UPDATE_ADMIN_GBG_PRODUCT:
            console.log('UPDATE_ADMIN_GBG_PRODUCT', state,  action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload._id});

            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                action.payload,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }

        case DELETE_ADMIN_GBG_PRODUCT:
            console.log('DELETE_ADMIN_GBG_PRODUCT', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.recordID});
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                total:state.total-1,
                data: updatedProducts
            }
        case ADD_SELECTED_GBG_PRODUCTS:
          //  console.log('ADD_SELECTED_GBG_PRODUCTS', state,  action.payload);
            var selectedProductsToAdd =_.map( action.payload, function (product) {
                return {_id:product._id, 'Brand':product.Brand, Model:product.Model}
            });
            var updatedSelectedProducts = _.uniq(state.selectedProducts.concat(selectedProductsToAdd));
            return {
                ...state,
                selectedProducts: updatedSelectedProducts
            }
        case CLEAR_SELECTED_GBG_PRODUCTS:
            console.log('CLEAR_SELECTED_GBG_PRODUCTS', state,  action.payload);
            return {
                ...state,
                selectedProducts: []
            }
        case REMOVE_SELECTED_GBG_PRODUCTS:
            console.log('REMOVE_SELECTED_GBG_PRODUCTS', state,  action.payload);
            var selectedProductsToRemove =_.map( action.payload, function (product) {
                return product._id;
            });
            var updatedSelectedProducts = _.differenceBy( state.selectedProducts, action.payload,'_id')
            var updatedSelectedProducts =  _.uniqBy(_.differenceBy( state.selectedProducts, action.payload,'_id'),'_id');
            console.log('updatedSelectedProducts', updatedSelectedProducts);

            return {
                ...state,
                selectedProducts: updatedSelectedProducts,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const getRecord = (state, id) => {
     return state.adminGBGProducts.data.filter(record => record._id === id)[0];
}